import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsCheckLg } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../app/hook";
import { Plans } from "../../../constants/plans.constant";
import { selectIsUserNew } from "../../../features/auth/auth.slice";
import { setChosenPlan } from "../../../features/dashboard.slice";
import IPlan from "../../../interfaces/models/plan.interface";

type Props = {};

const SiteFindBestPlanComponent = (props: Props) => {
  const { t } = useTranslation();
  const [isMonthly, setIsMonthly] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const is_user_new = useAppSelector(selectIsUserNew);
  const selectPlan = (plan: IPlan) => {
    dispatch(setChosenPlan(plan));
    navigate("../register");
  };

  const breadcrumbs: any[] = [
    {
      name: "Home",
      link: "/"
    },
    {
      name: "Pricing",
      link: ""
    }
  ];

  return (
    <section className="find-best-plan">
      <div className="find-best-plan-header">
        <Container>
          <Row>
            <Col>
              <Container fluid="xl">
                <Row className="pt-5">
                  <Col>
                    <Row>
                      <Col className="d-flex justify-content-center ">
                        <span className="fs-3 tw-text-zinc-400 font-sofiaSans text-uppercase tw-font-extrabold">
                          {t("home/SiteFindBestPlan/subTitle")}
                        </span>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col className="d-flex justify-content-center color-sixteenColor text-center p-0">
                        <h1 className="font-sofiaSans tw-font-extrabold">
                          {t("home/SiteFindBestPlan/title")}
                        </h1>
                      </Col>
                    </Row>

                    <Row className="tw-mt-3">
                      <Col className="text-center">
                        <span className="font-sofiaSans tw-text-indigo-400 tw-font-extrabold tw-text-lg ">
                          {t("home/SiteFindBestPlan/text-01")}
                        </span>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col
                        lg={{ span: 4, offset: 4 }}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div className=" p-2 rounded d-flex gap-1 bg-fifteenColor ">
                          <Button
                            size="sm"
                            onClick={() => {
                              setIsMonthly(false);
                            }}
                            className={`border-0 ${
                              isMonthly
                                ? "bg-transparent color-twentyOneColor"
                                : "bg-thirdColor"
                            } rounded p-1 px-3 fs-5`}
                          >
                            {t("home/SiteFindBestPlan/btn-01")}
                          </Button>
                          <Button
                            size="sm"
                            onClick={() => {
                              setIsMonthly(true);
                            }}
                            className={`border-0 ${
                              isMonthly
                                ? "bg-thirdColor"
                                : "bg-transparent color-twentyOneColor"
                            } rounded p-1 px-3 fs-5`}
                          >
                            {t("home/SiteFindBestPlan/btn-02")}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="find-best-plan-body">
        <Container fluid="xl">
          <Row className="gx-0">
            <Col>
              <Row className="gx-0 justify-content-center">
                {Plans.filter((dr) => dr?.isMonthly == isMonthly).map(
                  (plan, index) => (
                    <Col
                      lg="4"
                      md="4"
                      key={index}
                      className="p-0 xl:tw-w-[350px] xxl:tw-w-[380px] tw-mt-3 md:tw-mt-0"
                    >
                      <Row className="mx-0  ">
                        <Col>
                          <Row className="px-2">
                            <Col className="d-flex flex-column   justify-content-center  shadow tw-rounded-lg bg-secondColor md:tw-px-8 tw-py-5">
                              <Row className="m-0">
                                <Col className="p-0">
                                  <span
                                    className={`${plan.headerTitleClass} text-uppercase btn-sm rounded-4 d-flex justify-content-center tw-h-10`}
                                  >
                                    {t(plan.headerTitle)}
                                  </span>
                                </Col>
                              </Row>
                              <Row className="mx-0 tw-mt-8">
                                <Col
                                  lg={plan.icon ? 8 : 12}
                                  sm={plan.icon ? 8 : 12}
                                  xs={plan.icon ? 8 : 12}
                                  className="p-0"
                                >
                                  <Row>
                                    <Col>
                                      <h2 className="font-sofiaSans fw-bolder ">
                                        {t(plan.title)}
                                      </h2>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col className="position-relative w-100">
                                      <span className="fs-3 fw-bold sofiaSans">
                                        {t(plan.priceDescription)}
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row className=" tw-h-7">
                                    {plan.isDiscount && (
                                      <Col className="d-flex align-items-center gap-2">
                                        <span>{plan.discountIcon}</span>
                                        <span
                                          className={`font-sofiaSans fw-bold fs-4 color-forthColor pt-1 ${
                                            plan.discountLine
                                              ? "text-decoration-line-through"
                                              : ""
                                          }`}
                                        >
                                          {t(plan.discountDescription)}
                                        </span>
                                      </Col>
                                    )}
                                  </Row>
                                </Col>
                                {plan.icon && (
                                  <Col lg="4" sm="4" xs="4">
                                    {plan.icon}
                                  </Col>
                                )}
                              </Row>
                              <React.Fragment>
                                <Row className="mx-0 tw-mt-8">
                                  <Col className="p-0">
                                    <Button
                                      onClick={() => {
                                        selectPlan(plan);
                                      }}
                                      className={`w-100 d-flex justify-content-center tw-h-14 ${plan.buttonClass}`}
                                    >
                                      {is_user_new
                                        ? t(plan.is_user_new_button as string)
                                        : t(plan.button)}
                                    </Button>
                                  </Col>
                                </Row>
                                <div className="tw-mt-8">
                                  {plan.features.map((item, i) => {
                                    return (
                                      <Row key={i} className="mx-0 ">
                                        <Col
                                          className={`d-flex align-items-center gap-2  ${
                                            item.active ? "border-dotted " : ""
                                          }  p-1 rounded jus `}
                                        >
                                          <>
                                            <span className="  px-2 py-1  color-thirdColor">
                                              <BsCheckLg />
                                            </span>
                                            <span className="fs-5 font-sofiaSans ">
                                              {t(item.name)}
                                            </span>
                                          </>
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                </div>
                              </React.Fragment>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  )
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default SiteFindBestPlanComponent;
